import { createSlice } from "@reduxjs/toolkit";
import { registrationActions } from "./registration.actions";

export const REGISTRATION_FEATURE_KEY = "registration";

export interface RegistrationState {
  token: string | null;
  loading: boolean;
  error: string | null;
  userCreated: boolean;
  userCreationLoading: boolean;
  userCreationError: string | null;
}

export const initialRegistrationState: RegistrationState = {
  token: null,
  loading: false,
  error: null,
  userCreated: false,
  userCreationLoading: false,
  userCreationError: null,
};

export const registrationSlice = createSlice({
  name: REGISTRATION_FEATURE_KEY,
  initialState: initialRegistrationState,
  reducers: {
    clearRegistrationState: (state: RegistrationState) => {
      state.token = null;
      state.loading = false;
      state.error = null;
      state.userCreated = false;
      state.userCreationLoading = false;
      state.userCreationError = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(registrationActions.generateRegistrationToken.pending, (state: RegistrationState) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(registrationActions.generateRegistrationToken.fulfilled, (state: RegistrationState, action) => {
      state.loading = false;
      state.token = action.payload.token || action.payload.registrationToken || action.payload;
    });
    builder.addCase(registrationActions.generateRegistrationToken.rejected, (state: RegistrationState, action) => {
      state.loading = false;
      state.error = (action.payload as string) || action.error.message || "Registration token generation failed";
    });
    builder.addCase(registrationActions.createLegalUser.pending, (state: RegistrationState) => {
      state.userCreationLoading = true;
      state.userCreationError = null;
    });
    builder.addCase(registrationActions.createLegalUser.fulfilled, (state: RegistrationState, action) => {
      state.userCreationLoading = false;
      state.userCreated = true;
    });
    builder.addCase(registrationActions.createLegalUser.rejected, (state: RegistrationState, action) => {
      state.userCreationLoading = false;
      state.userCreationError = (action.payload as string) || action.error.message || "User creation failed";
    });
  },
});

export const registrationReducer = registrationSlice.reducer;